import React, { CSSProperties } from "react";
import { CircularProgress, Container, Stack } from "@mui/material";

interface Props {
  size?: number;
  style?: CSSProperties;
  color?: "success" | "info" | "warning" | "error" | "inherit" | "primary" | "secondary";
}

const Loading = ({ size, style, color }: Props) => {
  return (
    <Container
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...style,
      }}
    >
      <CircularProgress size={size ? size : 40} color={color ? color : "primary"} />
    </Container>
  );
};

export default Loading;
